import { render, staticRenderFns } from "./BenchmarkHoldings.vue?vue&type=template&id=898725ac&scoped=true&"
import script from "./BenchmarkHoldings.vue?vue&type=script&lang=js&"
export * from "./BenchmarkHoldings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898725ac",
  null
  
)

export default component.exports